import React from 'react';
import PropTypes from 'prop-types';
import './GlobalErrorPopup.css';

const GlobalErrorPopup = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="global-error-overlay">
      <div className="global-error-popup">
        <div className="global-error-header">
          <h2>Error</h2>
          <button onClick={onClose} className="global-error-close-button">
            &times;
          </button>
        </div>
        <div className="global-error-body">
          <p>{message}</p>
        </div>
        <div className="global-error-footer">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

GlobalErrorPopup.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default GlobalErrorPopup;
